import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/store';
import { setGimmickyInStore, setShowRateGraphInStore } from 'src/slices/bkvReducer';

export const useComparisonLogic = () => {
  const state = useSelector((state: RootState) => state.bkv);
  const dispatch = useDispatch();

  const handleComparisonLogic = (compareType: string) => {
    const isBKVE = BooleanBKVE(compareType);

    if (state.gimmicky) {
      let rateArr = [500, 1000, 1500, 2000, 2500].map((kwh) => {
        return {
          gimmicky: state.gimmicky[`kWh${kwh}` as keyof typeof state.gimmicky],
          bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
          kwh: kwh,
        };
      });
    } else {
      let rateArr = [500, 1000, 1500, 2000, 2500].map((kwh) => {
        return {
          bluebonnet: Number(state.bluebonnet?.rate?.replace("¢", "")),
          kwh: kwh,
        };
      });
    }

   
  };

  return { handleComparisonLogic };
};

const BooleanBKVE = (val: string): boolean => {
  const BKVE = ['Agave', 'Polyedra', 'Pepper Tree', 'Primrose', 'Paintbrush'];
  const Competitor = ['Bullseye', 'Base Fees', 'Bill Credit', 'Free Nights & Weekends', 'EV Charging'];
  
  if (BKVE.includes(val)) {
    return true;
  } else if (Competitor.includes(val)) {
    return false;
  } else {
    return false;
  }
};